import React from "react";
import { Scissors, Calculator } from "lucide-react";

// Uniform market-signal colors used everywhere these values appear next to DME.
export const SENTIMENT_COLOR = "#EF4444"; // red — Crowd Sentiment Baseline (scissors)
export const TRADES_COLOR = "#9CA3AF";    // gray — Observed Real Trades (calculator)

// Small icon badge shown beside a Crowd Sentiment value (red scissors).
export const SentimentTag = ({ className = "" }) => (
  <span
    title="Crowd Sentiment Baseline"
    data-testid="sentiment-tag"
    className={`inline-flex items-center justify-center w-4 h-4 rounded-sm align-middle ${className}`}
    style={{ color: SENTIMENT_COLOR, border: `1px solid ${SENTIMENT_COLOR}55`, background: `${SENTIMENT_COLOR}1a` }}
  >
    <Scissors className="w-2.5 h-2.5" />
  </span>
);

// Small icon badge shown beside an Observed Real Trades value (gray calculator).
export const RealTradesTag = ({ className = "" }) => (
  <span
    title="Observed Real Trades"
    data-testid="realtrades-tag"
    className={`inline-flex items-center justify-center w-4 h-4 rounded-sm align-middle ${className}`}
    style={{ color: TRADES_COLOR, border: `1px solid ${TRADES_COLOR}55`, background: `${TRADES_COLOR}1a` }}
  >
    <Calculator className="w-2.5 h-2.5" />
  </span>
);
